import {
  env
} from './env';

export const apiurl = envname => ({
  production: 'https://boxoffice.tivents.systems/v1/',
  development: 'https://verkauf-api-staging.intern.tivents.de/v1/'
}[env]);
